import React from 'react';
import { eventClickHandler as prematchEventClickHandler } from 'helpers/prematch';
import PropTypes from 'prop-types';

import {
  groupMarketTypeInstructions,
  SiteConfigManager,
  useCategoryState,
  usePreferences,
} from '@atlas/core';
import { ViewportDisplayController } from '@atlas/ui';

import useSelectedMarketType from 'hooks/useSelectedMarketType';

export const eventClickHandler = prematchEventClickHandler;

import { PrematchTournament } from './PrematchTournament';

const TournamentPlaceholder = React.forwardRef((props, ref) => {
  const { counter = 1 } = props;

  const style = {
    height: `${counter * 64}px`,
  };

  return <div className="tournament placeholder" ref={ref} style={style} />;
});

const CategoryTournamentsList = ({
  categoryId,
  clickedCategory,
  expandedCategory,
  isTopCompetitions = false,
  mainMarketTypes,
  primaryCategoryUrlName,
  primaryTournamentUrlName,
}) => {
  const { tournaments } = useCategoryState();
  const { favoriteTournaments } = usePreferences();
  const sportFormMainTypes = tournaments[0]?.sportForm;

  const selectedMarketType = useSelectedMarketType();

  const collapseCompetitions = SiteConfigManager.getConfig(
    'config.config.sportsbook.mobileCollapseCompetitions',
    false,
  );

  const sortedTournaments = React.useMemo(() => {
    const highestPriority = [];
    const highPriority = [];
    const mediumPriority = [];
    const lowPriority = [];

    const isHighestPriority = tournament =>
      tournament.tournamentUrlName === primaryTournamentUrlName ||
      tournament.urlName === primaryTournamentUrlName;

    const isHighPriority = tournament => tournament.categoryUrlName === primaryCategoryUrlName;

    const isFavorite = tournament => favoriteTournaments.includes(tournament.id);

    tournaments.map(a => {
      if (isHighestPriority(a)) return highestPriority.push(a);
      if (isHighPriority(a)) return highPriority.push(a);
      if (isFavorite(a)) return mediumPriority.push(a);
      return lowPriority.push(a);
    });

    return [...highestPriority, ...highPriority, ...mediumPriority, ...lowPriority];
  }, [favoriteTournaments, primaryCategoryUrlName, tournaments, primaryTournamentUrlName]);

  const sportMarketTypesPeriodMap = React.useMemo(
    () =>
      groupMarketTypeInstructions(mainMarketTypes, {
        isMultilines: !!(
          sportFormMainTypes &&
          SiteConfigManager.getConfig('config.config.sportsbook.showMobileMultilines')
        ),
        selectedMarketType,
        tournamentMainTypes: sportFormMainTypes,
      }),
    [mainMarketTypes, sportFormMainTypes, selectedMarketType],
  );

  return sortedTournaments.map((tournament, i) => (
    <div className="category" data-cid={categoryId} key={tournament.id}>
      <ViewportDisplayController
        counter={tournament.prematchCount + tournament.liveCount}
        placeholder={TournamentPlaceholder}
      >
        <PrematchTournament
          clickedCategory={clickedCategory}
          expandedCategory={expandedCategory}
          forceIsExpanded={isTopCompetitions ? !collapseCompetitions && i === 0 : i === 0}
          key={tournament.id}
          marketTypesPeriodMap={sportMarketTypesPeriodMap}
          onEventClick={prematchEventClickHandler}
          tournament={tournament}
        />
      </ViewportDisplayController>
    </div>
  ));
};

CategoryTournamentsList.propTypes = {
  clickedCategory: PropTypes.number,
  mainMarketTypes: PropTypes.object.isRequired,
};

export default CategoryTournamentsList;
